var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle"},[_c('div',{staticClass:"toggle-header",on:{"click":_vm.toggle}},[_c('i',{staticClass:"icon-wrap",class:{
        'arrow-up': !_vm.animatedArrow && _vm.toggled,
        'arrow-down': _vm.animatedArrow || !_vm.animatedArrow && !_vm.toggled,
        'open': _vm.animatedArrow && _vm.toggled,
        'close': _vm.animatedArrow && !_vm.toggled,
        'right': _vm.animatedArrow && _vm.animationRight,
      }}),_vm._v(" "),_c('h4',[_vm._v("\n      "+_vm._s(_vm.title)+"\n      "),_vm._t("title")],2)]),_vm._v(" "),_c('transition',{on:{"before-enter":_vm.setHeight,"enter":_vm.restoreHeight,"before-leave":_vm.restoreHeight,"leave":_vm.setHeight}},[(_vm.toggled)?_c('div',{staticClass:"content-wrap"},[_c('div',{staticClass:"content-wrap-inner"},[_vm._t("default")],2)]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-675adf94","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToggleContent.vue
// module id = null
// module chunks = 